import React from 'react'
import { FAQ } from 'components/FAQ/index.js'
import { CheckExerciseFormFAQItems } from 'pages/CheckExerciseForm/FAQ/Items/index.js'

export function CheckExerciseFormFAQ () {
  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <FAQ
      itemsComponent={<CheckExerciseFormFAQItems />}
    />
  )
}
